import { render, staticRenderFns } from "./ArticleMagazine.vue?vue&type=template&id=520575a7&"
import script from "./ArticleMagazine.vue?vue&type=script&lang=js&"
export * from "./ArticleMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports